export const wavyLinesFragmentShader = `#ifdef GL_ES
precision mediump float;
#endif

uniform vec2 u_resolution;
uniform vec2 u_mouse;
uniform float u_time;

// Plot a line on Y using a value between 0.0-1.0
float plotLine(vec2 st, float pct){
  return  smoothstep( pct-0.002, pct, st.y) -
          smoothstep( pct, pct+0.002, st.y);
}

float plotFatLine(vec2 st, float pct){
  return  step( pct, st.y) -
          step( pct, st.y);
}

float plot(vec2 st, float pct){
  return smoothstep( pct, pct+0.002, st.y);
}
vec2 normalizeMousePosition(vec2 u_mouse, vec2 u_resolution) {
    return vec2(max(0.0, min(1.0, u_mouse.x / u_resolution.x)), max(0.0, min(1.0, u_mouse.y / u_resolution.y)));
}

void main() {
	vec2 st = gl_FragCoord.xy/u_resolution;

    //float y = st.x;
    // Smooth interpolation between 0.1 and 0.9
    //float y = smoothstep(0.,1.,st.x);
	//float y = smoothstep(0.2,0.5,st.x) - smoothstep(0.5,0.8,st.x);
    
    //makes diagonal wavy line towards bottom
    //float y = (sin(st.x * 50.0)) * 0.03 + (st.x * 0.5); // Example function for y
    vec2 m = normalizeMousePosition(u_mouse, u_resolution);

    vec3 bgColor = vec3(1.0, 1.0, 1.0); //vec3(y);
    vec3 color01 = vec3(0.0, 1.0, 1.0);
    vec3 color02 = vec3(1.0, 0.0, 1.0);
    vec3 color03 = vec3(1.0, 1.0, 0.35);

    float wave01y = ((sin(st.x * 3.0 + (u_time * 0.52))) * 0.023 + pow(st.x * 0.52, 2.0)) + 0.2;
    float wave02y = (sin(st.x * 4.0 + (u_time * 0.58)) * 0.03 + pow((st.x * 0.76), 2.3)) + 0.1;
    float wave03y = ((sin(st.x * 3.0 + (u_time * 0.54))) * 0.03 + pow(st.x * 0.76, 2.0)) + 0.1;

    // Plot a wave
    float wave01 = plot(st, wave01y);
    float wave02 = plot(st, wave02y);
    float wave03 = plot(st, wave03y);

    vec3 resultColor01 = (1.0 - wave01)*color01+wave01;
    vec3 resultColor02 = (1.0 - wave02)*color02+wave02;
    vec3 resultColor03 = (1.0 - wave03)*color03+wave03;

    // Combine the colors based on the wave plots
    vec3 combinedColor = (resultColor01*resultColor02*resultColor03);
    if (combinedColor == vec3(0.0)) {
        combinedColor = bgColor; // Ensure we don't return black
    }

	gl_FragColor = vec4(combinedColor,1.0);
}
`;